// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Launchpad Management */
.launchpad-page .dashboard-body {
  padding-bottom: 2rem;
}

.launchpad-cards {
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  gap: 1rem;
  margin-bottom: 1.5rem;
}

.launchpad-card {
  background: #fff;
  border: 1px solid var(--border);
  border-radius: 12px;
  padding: 1.25rem;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 0.5rem;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.06);
}

.launchpad-card i {
  font-size: 1.5rem;
  color: var(--text-muted);
}

.launchpad-card__value {
  font-size: 1.5rem;
  font-weight: 700;
  color: #0f766e;
}

.launchpad-card__label {
  font-size: 0.85rem;
  color: var(--text-muted);
}

.launchpad-tabs {
  display: flex;
  gap: 0.25rem;
  margin-bottom: 1.5rem;
  flex-wrap: wrap;
}

.launchpad-tab {
  display: inline-flex;
  align-items: center;
  gap: 0.5rem;
  padding: 0.85rem 1.5rem;
  font-size: 0.95rem;
  font-weight: 600;
  font-family: inherit;
  color: var(--text-muted);
  background: #fff;
  border: 1px solid var(--border);
  border-radius: 10px;
  cursor: pointer;
  transition: all 0.2s;
}

.launchpad-tab:hover {
  color: #0f766e;
  border-color: #0f766e;
  background: #f0fdfa;
}

.launchpad-tab--active {
  color: #fff;
  background: linear-gradient(135deg, #0f766e 0%, #14b8a6 100%);
  border-color: transparent;
}

.launchpad-content {
  background: #fff;
  border-radius: 12px;
  border: 1px solid var(--border);
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.06);
  overflow: hidden;
}

.launchpad-section {
  padding: 1.5rem;
}

.launchpad-section__title {
  margin: 0 0 1.25rem;
  font-size: 1.15rem;
  font-weight: 700;
  color: var(--text);
  display: flex;
  align-items: center;
  gap: 0.5rem;
}

.launchpad-section__title i {
  color: #0f766e;
}

/* Launchpad List sub-tabs (Upcoming, Pending, Ended) */
.launchpad-list-tabs {
  display: flex;
  gap: 0.5rem;
  margin-bottom: 1.25rem;
  flex-wrap: wrap;
}

.launchpad-list-tab {
  padding: 0.6rem 1.25rem;
  font-size: 0.9rem;
  font-weight: 600;
  font-family: inherit;
  color: var(--text-muted);
  background: #f8fafc;
  border: 1px solid var(--border);
  border-radius: 8px;
  cursor: pointer;
  transition: all 0.2s;
}

.launchpad-list-tab:hover {
  color: #0f766e;
  border-color: #0f766e;
  background: #f0fdfa;
}

.launchpad-list-tab--active {
  color: #fff;
  background: linear-gradient(135deg, #0f766e 0%, #14b8a6 100%);
  border-color: transparent;
}

/* Create form */
.launchpad-form__group {
  margin-bottom: 1rem;
}

.launchpad-form__group label {
  display: block;
  margin-bottom: 0.4rem;
  font-size: 0.875rem;
  font-weight: 600;
  color: var(--text);
}

.launchpad-form__group .required {
  color: #dc2626;
}

.launchpad-form__group input,
.launchpad-form__group select,
.launchpad-form__group textarea {
  width: 100%;
  max-width: 100%;
  padding: 0.65rem 1rem;
  font-size: 0.9rem;
  font-family: inherit;
  border: 1px solid var(--border);
  border-radius: 8px;
  background: #fff;
  color: var(--text);
}

.launchpad-form__group input:focus,
.launchpad-form__group select:focus,
.launchpad-form__group textarea:focus {
  outline: none;
  border-color: #0f766e;
}

.launchpad-form__readonly {
  background: #f8fafc !important;
  color: var(--text-muted);
}

.launchpad-form__group textarea {
  resize: vertical;
  min-height: 100px;
}

.launchpad-form__block {
  margin-bottom: 1.5rem;
  padding-bottom: 1.5rem;
  border-bottom: 1px solid #f1f5f9;
}

.launchpad-form__block:last-of-type {
  border-bottom: none;
}

.launchpad-form__block h3 {
  margin: 0 0 1rem;
  font-size: 1rem;
  font-weight: 600;
  color: var(--text);
}

.launchpad-form__row {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 1rem;
}

.launchpad-form__grid {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(200px, 1fr));
  gap: 1rem;
}

.launchpad-form__file {
  display: flex;
  align-items: center;
  gap: 0.75rem;
  flex-wrap: wrap;
}

.launchpad-form__file input[type="file"] {
  width: 0.1px;
  height: 0.1px;
  opacity: 0;
  position: absolute;
}

.launchpad-form__file-btn {
  padding: 0.5rem 1rem;
  font-size: 0.875rem;
  font-weight: 500;
  background: #f1f5f9;
  color: var(--text);
  border: 1px solid var(--border);
  border-radius: 8px;
  cursor: pointer;
  transition: background 0.2s;
}

.launchpad-form__file-btn:hover {
  background: #e2e8f0;
}

.launchpad-form__file-text {
  font-size: 0.85rem;
  color: var(--text-muted);
}

.launchpad-form__actions {
  display: flex;
  gap: 1rem;
  justify-content: flex-end;
  margin-top: 1.5rem;
  padding-top: 1.5rem;
  border-top: 1px solid #f1f5f9;
}

.launchpad-btn {
  display: inline-flex;
  align-items: center;
  gap: 0.5rem;
  padding: 0.7rem 1.25rem;
  font-size: 0.9rem;
  font-weight: 600;
  font-family: inherit;
  border-radius: 8px;
  cursor: pointer;
  transition: opacity 0.2s;
}

.launchpad-btn--reset {
  background: #fff;
  color: var(--text);
  border: 1px solid var(--border);
}

.launchpad-btn--reset:hover {
  background: #f8fafc;
}

.launchpad-btn--publish {
  background: linear-gradient(135deg, #0f766e 0%, #14b8a6 100%);
  color: #fff;
  border: none;
  box-shadow: 0 2px 6px rgba(37, 99, 235, 0.35);
}

.launchpad-btn--publish:hover {
  opacity: 0.95;
}

/* Tables */
.launchpad-table-wrap {
  overflow-x: auto;
}

.launchpad-table {
  width: 100%;
  border-collapse: collapse;
  font-size: 0.875rem;
}

.launchpad-table th {
  padding: 0.9rem 1rem;
  text-align: left;
  font-weight: 600;
  font-size: 0.68rem;
  text-transform: uppercase;
  letter-spacing: 0.05em;
  color: #64748b;
  background: #f8fafc;
  border-bottom: 2px solid var(--border);
}

.launchpad-table td {
  padding: 0.9rem 1rem;
  border-bottom: 1px solid #f1f5f9;
  color: var(--text);
}

.launchpad-table tbody tr:nth-child(even) {
  background: #fafafa;
}

.launchpad-table tbody tr:hover {
  background: #f0fdfa !important;
}

.launchpad-status {
  display: inline-block;
  padding: 0.3rem 0.6rem;
  border-radius: 6px;
  font-size: 0.75rem;
  font-weight: 600;
}

.launchpad-status--upcoming {
  background: #fef3c7;
  color: #92400e;
}

.launchpad-status--live,
.launchpad-status--pending {
  background: #dcfce7;
  color: #166534;
}

.launchpad-status--ended {
  background: #f1f5f9;
  color: #64748b;
}

.launchpad-status--cancelled {
  background: #fef2f2;
  color: #b91c1c;
}

/* Action buttons in Launchpad List */
.launchpad-action-btns {
  display: flex;
  gap: 6px;
  flex-wrap: wrap;
}

.launchpad-action-btns .btn {
  padding: 0.35rem 0.65rem;
  font-size: 0.8rem;
  font-weight: 600;
  font-family: inherit;
  border: none;
  border-radius: 6px;
  cursor: pointer;
  transition: opacity 0.2s;
}

.launchpad-action-btns .btn:hover {
  opacity: 0.9;
}

.launchpad-action-btns .btn-sm.btn-success {
  background: #16a34a;
  color: #fff;
}

.launchpad-action-btns .btn-sm.btn-warning {
  background: #ca8a04;
  color: #fff;
}

.launchpad-action-btns .btn-sm.btn-danger {
  background: #dc2626;
  color: #fff;
}

.launchpad-action-status {
  font-weight: 700;
}

.launchpad-action-status--ended {
  color: #ea580c;
}

.launchpad-action-status--cancelled {
  color: #dc2626;
}

@media (max-width: 992px) {
  .launchpad-cards {
    grid-template-columns: repeat(2, 1fr);
  }

  .launchpad-form__row {
    grid-template-columns: 1fr;
  }
}

/* Messages */
.launchpad-message {
  margin-bottom: 1rem;
  padding: 0.85rem 1rem;
  border-radius: 8px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 0.5rem;
}

.launchpad-message--success {
  background: #dcfce7;
  color: #166534;
  border: 1px solid #86efac;
}

.launchpad-message--error {
  background: #fef2f2;
  color: #b91c1c;
  border: 1px solid #fecaca;
}

.launchpad-message__close {
  background: none;
  border: none;
  font-size: 1.25rem;
  cursor: pointer;
  opacity: 0.7;
  padding: 0 0.25rem;
}

.launchpad-message__close:hover {
  opacity: 1;
}

/* Hint text */
.launchpad-section__hint {
  margin: -0.5rem 0 1rem;
  font-size: 0.875rem;
  color: var(--text-muted);
}

/* Form validation */
.launchpad-form__error {
  border-color: #dc2626 !important;
}

.launchpad-form__err-text {
  display: block;
  font-size: 0.8rem;
  color: #dc2626;
  margin-top: 0.35rem;
}

.launchpad-form__char-count {
  display: block;
  font-size: 0.8rem;
  color: var(--text-muted);
  margin-top: 0.25rem;
}

.launchpad-form__hint {
  display: block;
  font-size: 0.8rem;
  color: var(--text-muted);
  margin-top: 0.35rem;
}

/* Loading */
.launchpad-loading {
  padding: 3rem;
  text-align: center;
  color: var(--text-muted);
}

.launchpad-loading i {
  margin-right: 0.5rem;
}

/* Table empty state */
.launchpad-table__empty {
  text-align: center;
  color: var(--text-muted);
  padding: 2rem !important;
}

/* Pagination */
.launchpad-pagination {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 1rem;
  padding: 1rem;
  border-top: 1px solid #f1f5f9;
}

.launchpad-pagination button {
  padding: 0.5rem 1rem;
  font-size: 0.9rem;
  font-weight: 600;
  font-family: inherit;
  background: #f8fafc;
  border: 1px solid var(--border);
  border-radius: 8px;
  cursor: pointer;
}

.launchpad-pagination button:hover:not(:disabled) {
  background: #0f766e;
  color: #fff;
  border-color: #0f766e;
}

.launchpad-pagination button:disabled {
  opacity: 0.5;
  cursor: not-allowed;
}

/* Edit button */
.launchpad-action-btns .btn-sm.btn-info {
  background: #0d9488;
  color: #fff;
}

/* Confirmation Modal */
.launchpad-confirm-overlay {
  position: fixed;
  inset: 0;
  background: rgba(0, 0, 0, 0.5);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 1001;
  padding: 1rem;
}

.launchpad-confirm-modal {
  background: #fff;
  border-radius: 12px;
  padding: 1.5rem;
  max-width: 420px;
  width: 100%;
  box-shadow: 0 20px 40px rgba(0, 0, 0, 0.2);
}

.launchpad-confirm-title {
  margin: 0 0 0.75rem;
  font-size: 1.15rem;
  font-weight: 700;
  color: var(--text);
  display: flex;
  align-items: center;
  gap: 0.5rem;
}

.launchpad-confirm-title i {
  color: #f59e0b;
}

.launchpad-confirm-text {
  margin: 0 0 1.25rem;
  font-size: 0.9rem;
  color: var(--text-muted);
  line-height: 1.5;
}

.launchpad-confirm-actions {
  display: flex;
  justify-content: flex-end;
  gap: 0.75rem;
}

/* Edit Modal */
.launchpad-modal-overlay {
  position: fixed;
  inset: 0;
  background: rgba(0, 0, 0, 0.5);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 1000;
  padding: 1rem;
}

.launchpad-modal {
  background: #fff;
  border-radius: 12px;
  max-width: 640px;
  width: 100%;
  max-height: 90vh;
  overflow-y: auto;
  box-shadow: 0 20px 60px rgba(0, 0, 0, 0.2);
}

.launchpad-modal__header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 1.25rem 1.5rem;
  border-bottom: 1px solid var(--border);
}

.launchpad-modal__header h3 {
  margin: 0;
  font-size: 1.15rem;
  font-weight: 700;
}

.launchpad-modal__close {
  background: none;
  border: none;
  font-size: 1.5rem;
  cursor: pointer;
  color: var(--text-muted);
  padding: 0 0.25rem;
  line-height: 1;
}

.launchpad-modal__close:hover {
  color: var(--text);
}

.launchpad-modal__body {
  padding: 1.5rem;
}

.launchpad-modal__body .launchpad-form__group {
  margin-bottom: 1rem;
}

.launchpad-modal__body .launchpad-form__row,
.launchpad-modal__body .launchpad-form__grid {
  margin-bottom: 1rem;
}

.launchpad-modal__actions {
  display: flex;
  gap: 1rem;
  justify-content: flex-end;
  margin-top: 1.5rem;
  padding-top: 1.5rem;
  border-top: 1px solid #f1f5f9;
}

.launchpad-form__err-block {
  margin-top: 0.5rem;
  padding: 0.75rem;
  background: #fef2f2;
  border-radius: 8px;
  font-size: 0.875rem;
  color: #b91c1c;
}

.launchpad-form__err-block span {
  display: block;
}

@media (max-width: 576px) {
  .launchpad-cards {
    grid-template-columns: 1fr;
  }

  .launchpad-form__grid {
    grid-template-columns: 1fr;
  }
}
`, "",{"version":3,"sources":["webpack://./src/pages/Dashboard/Exchange/LaunchpadManagementPage.css"],"names":[],"mappings":"AAAA,yBAAyB;AACzB;EACE,oBAAoB;AACtB;;AAEA;EACE,aAAa;EACb,qCAAqC;EACrC,SAAS;EACT,qBAAqB;AACvB;;AAEA;EACE,gBAAgB;EAChB,+BAA+B;EAC/B,mBAAmB;EACnB,gBAAgB;EAChB,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,WAAW;EACX,yCAAyC;AAC3C;;AAEA;EACE,iBAAiB;EACjB,wBAAwB;AAC1B;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,wBAAwB;AAC1B;;AAEA;EACE,aAAa;EACb,YAAY;EACZ,qBAAqB;EACrB,eAAe;AACjB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,WAAW;EACX,uBAAuB;EACvB,kBAAkB;EAClB,gBAAgB;EAChB,oBAAoB;EACpB,wBAAwB;EACxB,gBAAgB;EAChB,+BAA+B;EAC/B,mBAAmB;EACnB,eAAe;EACf,oBAAoB;AACtB;;AAEA;EACE,cAAc;EACd,qBAAqB;EACrB,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,6DAA6D;EAC7D,yBAAyB;AAC3B;;AAEA;EACE,gBAAgB;EAChB,mBAAmB;EACnB,+BAA+B;EAC/B,yCAAyC;EACzC,gBAAgB;AAClB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,mBAAmB;EACnB,kBAAkB;EAClB,gBAAgB;EAChB,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE,cAAc;AAChB;;AAEA,uDAAuD;AACvD;EACE,aAAa;EACb,WAAW;EACX,sBAAsB;EACtB,eAAe;AACjB;;AAEA;EACE,uBAAuB;EACvB,iBAAiB;EACjB,gBAAgB;EAChB,oBAAoB;EACpB,wBAAwB;EACxB,mBAAmB;EACnB,+BAA+B;EAC/B,kBAAkB;EAClB,eAAe;EACf,oBAAoB;AACtB;;AAEA;EACE,cAAc;EACd,qBAAqB;EACrB,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,6DAA6D;EAC7D,yBAAyB;AAC3B;;AAEA,gBAAgB;AAChB;EACE,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,qBAAqB;EACrB,mBAAmB;EACnB,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,cAAc;AAChB;;AAEA;;;EAGE,WAAW;EACX,eAAe;EACf,qBAAqB;EACrB,iBAAiB;EACjB,oBAAoB;EACpB,+BAA+B;EAC/B,kBAAkB;EAClB,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;;;EAGE,aAAa;EACb,qBAAqB;AACvB;;AAEA;EACE,8BAA8B;EAC9B,wBAAwB;AAC1B;;AAEA;EACE,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,qBAAqB;EACrB,sBAAsB;EACtB,gCAAgC;AAClC;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,SAAS;AACX;;AAEA;EACE,aAAa;EACb,4DAA4D;EAC5D,SAAS;AACX;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,YAAY;EACZ,eAAe;AACjB;;AAEA;EACE,YAAY;EACZ,aAAa;EACb,UAAU;EACV,kBAAkB;AACpB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,gBAAgB;EAChB,mBAAmB;EACnB,kBAAkB;EAClB,+BAA+B;EAC/B,kBAAkB;EAClB,eAAe;EACf,2BAA2B;AAC7B;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,wBAAwB;AAC1B;;AAEA;EACE,aAAa;EACb,SAAS;EACT,yBAAyB;EACzB,kBAAkB;EAClB,mBAAmB;EACnB,6BAA6B;AAC/B;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,WAAW;EACX,uBAAuB;EACvB,iBAAiB;EACjB,gBAAgB;EAChB,oBAAoB;EACpB,kBAAkB;EAClB,eAAe;EACf,wBAAwB;AAC1B;;AAEA;EACE,gBAAgB;EAChB,kBAAkB;EAClB,+BAA+B;AACjC;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,6DAA6D;EAC7D,WAAW;EACX,YAAY;EACZ,6CAA6C;AAC/C;;AAEA;EACE,aAAa;AACf;;AAEA,WAAW;AACX;EACE,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,yBAAyB;EACzB,mBAAmB;AACrB;;AAEA;EACE,oBAAoB;EACpB,gBAAgB;EAChB,gBAAgB;EAChB,kBAAkB;EAClB,yBAAyB;EACzB,sBAAsB;EACtB,cAAc;EACd,mBAAmB;EACnB,sCAAsC;AACxC;;AAEA;EACE,oBAAoB;EACpB,gCAAgC;EAChC,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,8BAA8B;AAChC;;AAEA;EACE,qBAAqB;EACrB,sBAAsB;EACtB,kBAAkB;EAClB,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;;EAEE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA,qCAAqC;AACrC;EACE,aAAa;EACb,QAAQ;EACR,eAAe;AACjB;;AAEA;EACE,wBAAwB;EACxB,iBAAiB;EACjB,gBAAgB;EAChB,oBAAoB;EACpB,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,wBAAwB;AAC1B;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE;IACE,qCAAqC;EACvC;;EAEA;IACE,0BAA0B;EAC5B;AACF;;AAEA,aAAa;AACb;EACE,mBAAmB;EACnB,qBAAqB;EACrB,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,WAAW;AACb;;AAEA;EACE,mBAAmB;EACnB,cAAc;EACd,yBAAyB;AAC3B;;AAEA;EACE,mBAAmB;EACnB,cAAc;EACd,yBAAyB;AAC3B;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,YAAY;EACZ,kBAAkB;AACpB;;AAEA;EACE,UAAU;AACZ;;AAEA,cAAc;AACd;EACE,sBAAsB;EACtB,mBAAmB;EACnB,wBAAwB;AAC1B;;AAEA,oBAAoB;AACpB;EACE,gCAAgC;AAClC;;AAEA;EACE,cAAc;EACd,iBAAiB;EACjB,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,iBAAiB;EACjB,wBAAwB;EACxB,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,iBAAiB;EACjB,wBAAwB;EACxB,mBAAmB;AACrB;;AAEA,YAAY;AACZ;EACE,aAAa;EACb,kBAAkB;EAClB,wBAAwB;AAC1B;;AAEA;EACE,oBAAoB;AACtB;;AAEA,sBAAsB;AACtB;EACE,kBAAkB;EAClB,wBAAwB;EACxB,wBAAwB;AAC1B;;AAEA,eAAe;AACf;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,SAAS;EACT,aAAa;EACb,6BAA6B;AAC/B;;AAEA;EACE,oBAAoB;EACpB,iBAAiB;EACjB,gBAAgB;EAChB,oBAAoB;EACpB,mBAAmB;EACnB,+BAA+B;EAC/B,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,mBAAmB;EACnB,WAAW;EACX,qBAAqB;AACvB;;AAEA;EACE,YAAY;EACZ,mBAAmB;AACrB;;AAEA,gBAAgB;AAChB;EACE,mBAAmB;EACnB,WAAW;AACb;;AAEA,uBAAuB;AACvB;EACE,eAAe;EACf,QAAQ;EACR,8BAA8B;EAC9B,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,aAAa;EACb,aAAa;AACf;;AAEA;EACE,gBAAgB;EAChB,mBAAmB;EACnB,eAAe;EACf,gBAAgB;EAChB,WAAW;EACX,0CAA0C;AAC5C;;AAEA;EACE,mBAAmB;EACnB,kBAAkB;EAClB,gBAAgB;EAChB,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,iBAAiB;EACjB,wBAAwB;EACxB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,yBAAyB;EACzB,YAAY;AACd;;AAEA,eAAe;AACf;EACE,eAAe;EACf,QAAQ;EACR,8BAA8B;EAC9B,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,aAAa;EACb,aAAa;AACf;;AAEA;EACE,gBAAgB;EAChB,mBAAmB;EACnB,gBAAgB;EAChB,WAAW;EACX,gBAAgB;EAChB,gBAAgB;EAChB,0CAA0C;AAC5C;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,uBAAuB;EACvB,sCAAsC;AACxC;;AAEA;EACE,SAAS;EACT,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,iBAAiB;EACjB,eAAe;EACf,wBAAwB;EACxB,kBAAkB;EAClB,cAAc;AAChB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;;EAEE,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,SAAS;EACT,yBAAyB;EACzB,kBAAkB;EAClB,mBAAmB;EACnB,6BAA6B;AAC/B;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;EACnB,kBAAkB;EAClB,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE;IACE,0BAA0B;EAC5B;;EAEA;IACE,0BAA0B;EAC5B;AACF","sourcesContent":["/* Launchpad Management */\n.launchpad-page .dashboard-body {\n  padding-bottom: 2rem;\n}\n\n.launchpad-cards {\n  display: grid;\n  grid-template-columns: repeat(4, 1fr);\n  gap: 1rem;\n  margin-bottom: 1.5rem;\n}\n\n.launchpad-card {\n  background: #fff;\n  border: 1px solid var(--border);\n  border-radius: 12px;\n  padding: 1.25rem;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  gap: 0.5rem;\n  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.06);\n}\n\n.launchpad-card i {\n  font-size: 1.5rem;\n  color: var(--text-muted);\n}\n\n.launchpad-card__value {\n  font-size: 1.5rem;\n  font-weight: 700;\n  color: #0f766e;\n}\n\n.launchpad-card__label {\n  font-size: 0.85rem;\n  color: var(--text-muted);\n}\n\n.launchpad-tabs {\n  display: flex;\n  gap: 0.25rem;\n  margin-bottom: 1.5rem;\n  flex-wrap: wrap;\n}\n\n.launchpad-tab {\n  display: inline-flex;\n  align-items: center;\n  gap: 0.5rem;\n  padding: 0.85rem 1.5rem;\n  font-size: 0.95rem;\n  font-weight: 600;\n  font-family: inherit;\n  color: var(--text-muted);\n  background: #fff;\n  border: 1px solid var(--border);\n  border-radius: 10px;\n  cursor: pointer;\n  transition: all 0.2s;\n}\n\n.launchpad-tab:hover {\n  color: #0f766e;\n  border-color: #0f766e;\n  background: #f0fdfa;\n}\n\n.launchpad-tab--active {\n  color: #fff;\n  background: linear-gradient(135deg, #0f766e 0%, #14b8a6 100%);\n  border-color: transparent;\n}\n\n.launchpad-content {\n  background: #fff;\n  border-radius: 12px;\n  border: 1px solid var(--border);\n  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.06);\n  overflow: hidden;\n}\n\n.launchpad-section {\n  padding: 1.5rem;\n}\n\n.launchpad-section__title {\n  margin: 0 0 1.25rem;\n  font-size: 1.15rem;\n  font-weight: 700;\n  color: var(--text);\n  display: flex;\n  align-items: center;\n  gap: 0.5rem;\n}\n\n.launchpad-section__title i {\n  color: #0f766e;\n}\n\n/* Launchpad List sub-tabs (Upcoming, Pending, Ended) */\n.launchpad-list-tabs {\n  display: flex;\n  gap: 0.5rem;\n  margin-bottom: 1.25rem;\n  flex-wrap: wrap;\n}\n\n.launchpad-list-tab {\n  padding: 0.6rem 1.25rem;\n  font-size: 0.9rem;\n  font-weight: 600;\n  font-family: inherit;\n  color: var(--text-muted);\n  background: #f8fafc;\n  border: 1px solid var(--border);\n  border-radius: 8px;\n  cursor: pointer;\n  transition: all 0.2s;\n}\n\n.launchpad-list-tab:hover {\n  color: #0f766e;\n  border-color: #0f766e;\n  background: #f0fdfa;\n}\n\n.launchpad-list-tab--active {\n  color: #fff;\n  background: linear-gradient(135deg, #0f766e 0%, #14b8a6 100%);\n  border-color: transparent;\n}\n\n/* Create form */\n.launchpad-form__group {\n  margin-bottom: 1rem;\n}\n\n.launchpad-form__group label {\n  display: block;\n  margin-bottom: 0.4rem;\n  font-size: 0.875rem;\n  font-weight: 600;\n  color: var(--text);\n}\n\n.launchpad-form__group .required {\n  color: #dc2626;\n}\n\n.launchpad-form__group input,\n.launchpad-form__group select,\n.launchpad-form__group textarea {\n  width: 100%;\n  max-width: 100%;\n  padding: 0.65rem 1rem;\n  font-size: 0.9rem;\n  font-family: inherit;\n  border: 1px solid var(--border);\n  border-radius: 8px;\n  background: #fff;\n  color: var(--text);\n}\n\n.launchpad-form__group input:focus,\n.launchpad-form__group select:focus,\n.launchpad-form__group textarea:focus {\n  outline: none;\n  border-color: #0f766e;\n}\n\n.launchpad-form__readonly {\n  background: #f8fafc !important;\n  color: var(--text-muted);\n}\n\n.launchpad-form__group textarea {\n  resize: vertical;\n  min-height: 100px;\n}\n\n.launchpad-form__block {\n  margin-bottom: 1.5rem;\n  padding-bottom: 1.5rem;\n  border-bottom: 1px solid #f1f5f9;\n}\n\n.launchpad-form__block:last-of-type {\n  border-bottom: none;\n}\n\n.launchpad-form__block h3 {\n  margin: 0 0 1rem;\n  font-size: 1rem;\n  font-weight: 600;\n  color: var(--text);\n}\n\n.launchpad-form__row {\n  display: grid;\n  grid-template-columns: 1fr 1fr;\n  gap: 1rem;\n}\n\n.launchpad-form__grid {\n  display: grid;\n  grid-template-columns: repeat(auto-fill, minmax(200px, 1fr));\n  gap: 1rem;\n}\n\n.launchpad-form__file {\n  display: flex;\n  align-items: center;\n  gap: 0.75rem;\n  flex-wrap: wrap;\n}\n\n.launchpad-form__file input[type=\"file\"] {\n  width: 0.1px;\n  height: 0.1px;\n  opacity: 0;\n  position: absolute;\n}\n\n.launchpad-form__file-btn {\n  padding: 0.5rem 1rem;\n  font-size: 0.875rem;\n  font-weight: 500;\n  background: #f1f5f9;\n  color: var(--text);\n  border: 1px solid var(--border);\n  border-radius: 8px;\n  cursor: pointer;\n  transition: background 0.2s;\n}\n\n.launchpad-form__file-btn:hover {\n  background: #e2e8f0;\n}\n\n.launchpad-form__file-text {\n  font-size: 0.85rem;\n  color: var(--text-muted);\n}\n\n.launchpad-form__actions {\n  display: flex;\n  gap: 1rem;\n  justify-content: flex-end;\n  margin-top: 1.5rem;\n  padding-top: 1.5rem;\n  border-top: 1px solid #f1f5f9;\n}\n\n.launchpad-btn {\n  display: inline-flex;\n  align-items: center;\n  gap: 0.5rem;\n  padding: 0.7rem 1.25rem;\n  font-size: 0.9rem;\n  font-weight: 600;\n  font-family: inherit;\n  border-radius: 8px;\n  cursor: pointer;\n  transition: opacity 0.2s;\n}\n\n.launchpad-btn--reset {\n  background: #fff;\n  color: var(--text);\n  border: 1px solid var(--border);\n}\n\n.launchpad-btn--reset:hover {\n  background: #f8fafc;\n}\n\n.launchpad-btn--publish {\n  background: linear-gradient(135deg, #0f766e 0%, #14b8a6 100%);\n  color: #fff;\n  border: none;\n  box-shadow: 0 2px 6px rgba(37, 99, 235, 0.35);\n}\n\n.launchpad-btn--publish:hover {\n  opacity: 0.95;\n}\n\n/* Tables */\n.launchpad-table-wrap {\n  overflow-x: auto;\n}\n\n.launchpad-table {\n  width: 100%;\n  border-collapse: collapse;\n  font-size: 0.875rem;\n}\n\n.launchpad-table th {\n  padding: 0.9rem 1rem;\n  text-align: left;\n  font-weight: 600;\n  font-size: 0.68rem;\n  text-transform: uppercase;\n  letter-spacing: 0.05em;\n  color: #64748b;\n  background: #f8fafc;\n  border-bottom: 2px solid var(--border);\n}\n\n.launchpad-table td {\n  padding: 0.9rem 1rem;\n  border-bottom: 1px solid #f1f5f9;\n  color: var(--text);\n}\n\n.launchpad-table tbody tr:nth-child(even) {\n  background: #fafafa;\n}\n\n.launchpad-table tbody tr:hover {\n  background: #f0fdfa !important;\n}\n\n.launchpad-status {\n  display: inline-block;\n  padding: 0.3rem 0.6rem;\n  border-radius: 6px;\n  font-size: 0.75rem;\n  font-weight: 600;\n}\n\n.launchpad-status--upcoming {\n  background: #fef3c7;\n  color: #92400e;\n}\n\n.launchpad-status--live,\n.launchpad-status--pending {\n  background: #dcfce7;\n  color: #166534;\n}\n\n.launchpad-status--ended {\n  background: #f1f5f9;\n  color: #64748b;\n}\n\n.launchpad-status--cancelled {\n  background: #fef2f2;\n  color: #b91c1c;\n}\n\n/* Action buttons in Launchpad List */\n.launchpad-action-btns {\n  display: flex;\n  gap: 6px;\n  flex-wrap: wrap;\n}\n\n.launchpad-action-btns .btn {\n  padding: 0.35rem 0.65rem;\n  font-size: 0.8rem;\n  font-weight: 600;\n  font-family: inherit;\n  border: none;\n  border-radius: 6px;\n  cursor: pointer;\n  transition: opacity 0.2s;\n}\n\n.launchpad-action-btns .btn:hover {\n  opacity: 0.9;\n}\n\n.launchpad-action-btns .btn-sm.btn-success {\n  background: #16a34a;\n  color: #fff;\n}\n\n.launchpad-action-btns .btn-sm.btn-warning {\n  background: #ca8a04;\n  color: #fff;\n}\n\n.launchpad-action-btns .btn-sm.btn-danger {\n  background: #dc2626;\n  color: #fff;\n}\n\n.launchpad-action-status {\n  font-weight: 700;\n}\n\n.launchpad-action-status--ended {\n  color: #ea580c;\n}\n\n.launchpad-action-status--cancelled {\n  color: #dc2626;\n}\n\n@media (max-width: 992px) {\n  .launchpad-cards {\n    grid-template-columns: repeat(2, 1fr);\n  }\n\n  .launchpad-form__row {\n    grid-template-columns: 1fr;\n  }\n}\n\n/* Messages */\n.launchpad-message {\n  margin-bottom: 1rem;\n  padding: 0.85rem 1rem;\n  border-radius: 8px;\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 0.5rem;\n}\n\n.launchpad-message--success {\n  background: #dcfce7;\n  color: #166534;\n  border: 1px solid #86efac;\n}\n\n.launchpad-message--error {\n  background: #fef2f2;\n  color: #b91c1c;\n  border: 1px solid #fecaca;\n}\n\n.launchpad-message__close {\n  background: none;\n  border: none;\n  font-size: 1.25rem;\n  cursor: pointer;\n  opacity: 0.7;\n  padding: 0 0.25rem;\n}\n\n.launchpad-message__close:hover {\n  opacity: 1;\n}\n\n/* Hint text */\n.launchpad-section__hint {\n  margin: -0.5rem 0 1rem;\n  font-size: 0.875rem;\n  color: var(--text-muted);\n}\n\n/* Form validation */\n.launchpad-form__error {\n  border-color: #dc2626 !important;\n}\n\n.launchpad-form__err-text {\n  display: block;\n  font-size: 0.8rem;\n  color: #dc2626;\n  margin-top: 0.35rem;\n}\n\n.launchpad-form__char-count {\n  display: block;\n  font-size: 0.8rem;\n  color: var(--text-muted);\n  margin-top: 0.25rem;\n}\n\n.launchpad-form__hint {\n  display: block;\n  font-size: 0.8rem;\n  color: var(--text-muted);\n  margin-top: 0.35rem;\n}\n\n/* Loading */\n.launchpad-loading {\n  padding: 3rem;\n  text-align: center;\n  color: var(--text-muted);\n}\n\n.launchpad-loading i {\n  margin-right: 0.5rem;\n}\n\n/* Table empty state */\n.launchpad-table__empty {\n  text-align: center;\n  color: var(--text-muted);\n  padding: 2rem !important;\n}\n\n/* Pagination */\n.launchpad-pagination {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  gap: 1rem;\n  padding: 1rem;\n  border-top: 1px solid #f1f5f9;\n}\n\n.launchpad-pagination button {\n  padding: 0.5rem 1rem;\n  font-size: 0.9rem;\n  font-weight: 600;\n  font-family: inherit;\n  background: #f8fafc;\n  border: 1px solid var(--border);\n  border-radius: 8px;\n  cursor: pointer;\n}\n\n.launchpad-pagination button:hover:not(:disabled) {\n  background: #0f766e;\n  color: #fff;\n  border-color: #0f766e;\n}\n\n.launchpad-pagination button:disabled {\n  opacity: 0.5;\n  cursor: not-allowed;\n}\n\n/* Edit button */\n.launchpad-action-btns .btn-sm.btn-info {\n  background: #0d9488;\n  color: #fff;\n}\n\n/* Confirmation Modal */\n.launchpad-confirm-overlay {\n  position: fixed;\n  inset: 0;\n  background: rgba(0, 0, 0, 0.5);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  z-index: 1001;\n  padding: 1rem;\n}\n\n.launchpad-confirm-modal {\n  background: #fff;\n  border-radius: 12px;\n  padding: 1.5rem;\n  max-width: 420px;\n  width: 100%;\n  box-shadow: 0 20px 40px rgba(0, 0, 0, 0.2);\n}\n\n.launchpad-confirm-title {\n  margin: 0 0 0.75rem;\n  font-size: 1.15rem;\n  font-weight: 700;\n  color: var(--text);\n  display: flex;\n  align-items: center;\n  gap: 0.5rem;\n}\n\n.launchpad-confirm-title i {\n  color: #f59e0b;\n}\n\n.launchpad-confirm-text {\n  margin: 0 0 1.25rem;\n  font-size: 0.9rem;\n  color: var(--text-muted);\n  line-height: 1.5;\n}\n\n.launchpad-confirm-actions {\n  display: flex;\n  justify-content: flex-end;\n  gap: 0.75rem;\n}\n\n/* Edit Modal */\n.launchpad-modal-overlay {\n  position: fixed;\n  inset: 0;\n  background: rgba(0, 0, 0, 0.5);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  z-index: 1000;\n  padding: 1rem;\n}\n\n.launchpad-modal {\n  background: #fff;\n  border-radius: 12px;\n  max-width: 640px;\n  width: 100%;\n  max-height: 90vh;\n  overflow-y: auto;\n  box-shadow: 0 20px 60px rgba(0, 0, 0, 0.2);\n}\n\n.launchpad-modal__header {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  padding: 1.25rem 1.5rem;\n  border-bottom: 1px solid var(--border);\n}\n\n.launchpad-modal__header h3 {\n  margin: 0;\n  font-size: 1.15rem;\n  font-weight: 700;\n}\n\n.launchpad-modal__close {\n  background: none;\n  border: none;\n  font-size: 1.5rem;\n  cursor: pointer;\n  color: var(--text-muted);\n  padding: 0 0.25rem;\n  line-height: 1;\n}\n\n.launchpad-modal__close:hover {\n  color: var(--text);\n}\n\n.launchpad-modal__body {\n  padding: 1.5rem;\n}\n\n.launchpad-modal__body .launchpad-form__group {\n  margin-bottom: 1rem;\n}\n\n.launchpad-modal__body .launchpad-form__row,\n.launchpad-modal__body .launchpad-form__grid {\n  margin-bottom: 1rem;\n}\n\n.launchpad-modal__actions {\n  display: flex;\n  gap: 1rem;\n  justify-content: flex-end;\n  margin-top: 1.5rem;\n  padding-top: 1.5rem;\n  border-top: 1px solid #f1f5f9;\n}\n\n.launchpad-form__err-block {\n  margin-top: 0.5rem;\n  padding: 0.75rem;\n  background: #fef2f2;\n  border-radius: 8px;\n  font-size: 0.875rem;\n  color: #b91c1c;\n}\n\n.launchpad-form__err-block span {\n  display: block;\n}\n\n@media (max-width: 576px) {\n  .launchpad-cards {\n    grid-template-columns: 1fr;\n  }\n\n  .launchpad-form__grid {\n    grid-template-columns: 1fr;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
